import React from "react";
import {MuiIcon, MuiIconExternalProps, MuiIconProps} from "./MuiIcon";


export const BadgeIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\uea67'}</MuiIcon>
    );
}
